/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        chip: {
            paddingHorizontal: {
                value: "10px",
                type: "dimension",
            },
            height: {
                value: "24px",
                type: "dimension",
            },
            gap: {
                value: "12px",
                type: "dimension",
            },
            fontSize: {
                value: "0.75rem",
                type: "dimension",
            },
            lineHeight: {
                value: "0.875rem",
                type: "dimension",
            },
            fontWeight: {
                value: 400,
                type: "fontWeight",
            },
            color: {
                value: "#1e1e1e",
                type: "color",
            },
            backgroundColor: {
                value: "#e6e6e6",
                type: "color",
            },
            borderStyle: {
                value: "solid",
                type: "string",
            },
            borderWidth: {
                value: "1px",
                type: "dimension",
            },
            default: {
                borderColor: {
                    value: "#676767",
                    type: "color",
                },
            },
            hover: {
                borderColor: {
                    value: "#676767",
                    type: "color",
                },
                backgroundColor: {
                    value: "#EBEEF2",
                    type: "color",
                },
            },
            disabled: {
                borderWidth: {
                    value: "0",
                    type: "dimension",
                },
                backgroundColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
                color: {
                    value: "#b3b3b3",
                    type: "color",
                },
            },
            icon: {
                width: {
                    value: "16px",
                    type: "dimension",
                },
                height: {
                    value: "16px",
                    type: "dimension",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
            },
            avatar: {
                width: {
                    value: "20px",
                    type: "dimension",
                },
                height: {
                    value: "20px",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
